import axios from 'axios';

const onecodeAPI = axios.create({
    baseURL: "https://api.onecode.in",
    timeout: 5 * 60 * 1000,
  });

export {
    onecodeAPI
}
